import * as React from 'react'
import { connect } from 'react-redux'

import { TYPE } from 'components/Button'
import ButtonGroup from 'components/ButtonGroup'
import { ButtonGroupType } from 'components/ButtonGroup/ButtonGroup'
import Icon from 'components/Icon'
import { AppState } from '../../../data/state'

import { SRPRS } from 'Icon/srprs'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../../data/models/locale'
import IfCountry from '../../../elements/conditionals/IfCountry'
import { SButton } from '../../../routing/linkButton'

export enum IconType {
  blue = 'blue',
  colored = 'colored',
}

export interface TransportLinkSwitchProps {
  theme: Theme
  iconType?: IconType
}

export enum TransportType {
  fly,
  drive,
}

const TransportLinkSwitch: React.FC<TransportLinkSwitchProps> = props => {
  return (
    <IfCountry country={[SiteCountry.nl, SiteCountry.be]}>
      <ButtonGroup
        id={`TransportLinkSwitch`}
        type={ButtonGroupType.transportToggle}
        noTransform={true}
      >
        <SButton
          className={`transport-switch`}
          name={getSwitchName(props.theme, TransportType.fly)}
          type={
            props.theme === Theme.fly || props.theme === Theme.multiFly
              ? TYPE.angel
              : TYPE.ghost
          }
        >
          <Icon
            className="transport-switch"
            {...(props?.iconType === IconType.blue && {
              viewBox: '0 0 47 47',
              iconProps: { fill: 'none' },
            })}
            icon={
              props?.iconType === IconType.blue
                ? SRPRS.airplaneBlue
                : SRPRS.aeroplaneColored
            }
          />
        </SButton>
        <SButton
          className={`transport-switch`}
          name={getSwitchName(props.theme, TransportType.drive)}
          type={
            props.theme === Theme.drive || props.theme === Theme.multiDrive
              ? TYPE.angel
              : TYPE.ghost
          }
        >
          <Icon
            className="transport-switch"
            {...(props?.iconType === IconType.blue && {
              viewBox: '0 0 67 38',
              iconProps: { fill: 'none' },
            })}
            icon={
              props?.iconType === IconType.blue
                ? SRPRS.carBlue
                : SRPRS.carColored
            }
          />
        </SButton>
        <IfCountry country={[SiteCountry.nl]}>
          <SButton
            type={TYPE.ghost}
            name="entryPage"
            params={{ code: 'train', theme: Theme.train }}
          >
            <Icon
              className="transport-switch"
              {...(props?.iconType === IconType.blue && {
                viewBox: '0 0 68 45',
                iconProps: { fill: 'none' },
              })}
              icon={
                props?.iconType === IconType.blue
                  ? SRPRS.trainBlue
                  : SRPRS.trainColored
              }
            />
          </SButton>
        </IfCountry>
      </ButtonGroup>
    </IfCountry>
  )
}

TransportLinkSwitch.defaultProps = {
  iconType: IconType.colored,
}

export default connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
}))(TransportLinkSwitch)

function getSwitchName(theme: Theme, type: TransportType): string {
  const isMulti = theme === Theme.multiFly || theme === Theme.multiDrive

  switch (type) {
    case TransportType.drive:
      return isMulti ? 'multidrivecustomise' : 'drivecustomise'
    default:
    case TransportType.fly:
      return isMulti ? 'multiflycustomise' : 'flycustomise'
  }
}
